import { format } from 'date-fns'
import { option as O, function as F } from 'fp-ts'

const DEFAULT_FORMAT = 'M/dd/yyyy HH:mm a'

export const formatDate = (
  date?: string | Date,
  options?: {
    readonly format?: string
    readonly placeHolder?: string
  }
): string => {
  return F.pipe(
    date,
    O.fromNullable,
    O.map((d) =>
      format(
        d instanceof Date ? d : new Date(d),
        options?.format || DEFAULT_FORMAT
      )
    ),
    O.getOrElse(() => options?.placeHolder || '')
  )
}
